// extracted by mini-css-extract-plugin
module.exports = {"term":"term_3FF","termLink":"termLink_2gU"};